import { Stack } from "@mui/material";
import { memo } from "react";

import Notifications from "../../../Notifications/Notifications";
import { Alert } from "../../Alert/Alert";
import ThemeSwitch from "../../ThemeSwitch";
import AvatarDropdown from "../AvatarDropdown";
import LanguageSwitch from "../LanguageSwitch";

const HeaderRight = () => {
  const token = localStorage.getItem("access_tokens");

  return (
    <Stack direction={"row"} justifyContent={"end"} alignItems={"center"}>
      {token && <Alert />}

      {token && <Notifications />}

      <ThemeSwitch />

      {!token && <LanguageSwitch />}

      <AvatarDropdown />
    </Stack>
  );
};

export default memo(HeaderRight);
